import styled from "@emotion/styled";

const BriochePart = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-flow: row wrap;
  justify-items: center;
  align-content: space-between;
  font-feature-settings:
    "liga" off,
    "clig" off;
  /* Body/Little2 */
  font-family: "STK Bureau", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.28px;
`;

const IconPart = styled(BriochePart)`
  flex: 0 0 auto;
`;

const ContentPart = styled(BriochePart)``;

const ControlsPart = styled(BriochePart)`
  button,
  a {
    border: none;
    margin: 0;
    padding: 0;
    text-decoration: underline;
    cursor: pointer;
    pointer-events: all;
    background: transparent;
    color: inherit;
    &:visited {
      color: inherit;
    }
  }
`;

/**
 * Default styling for the Brioche, Themes might override these settings
 */
export const BriocheStyled = {
  IconPart,
  ContentPart,
  ControlsPart
};
